import { useEffect } from "react";

const LandingPage = () => {
    const baseUrl = process.env.REACT_APP_BASEURL;
    useEffect(() => {
        console.log(baseUrl);
    }, [])
    return (
        <div id="body" className="index-page">
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="container-fluid container-xl position-relative d-flex align-items-center">
                    <a href={`${baseUrl}`} className="logo d-flex align-items-center me-auto">
                        <img src={`${baseUrl}/assets/img/kemenag_logo.png`} alt="" />
                        <h1 className="sitename">E-Office</h1>
                    </a>
                    <a className="btn-getstarted flex-md-shrink-0" href={`/login`}>Masuk</a>
                </div>
            </header>
            <main className="main">
                <section id="hero" className="hero section">
                    <div className="container">
                        <div className="row gy-4">
                            <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center">
                                <h1 data-aos="fade-up">Aplikasi E-Office Kementerian Agama RI </h1>
                                <p data-aos="fade-up" data-aos-delay="100">adalah platform digital yang dirancang untuk mendukung pengelolaan administrasi perkantoran secara elektronik di lingkungan Kementerian Agama Republik Indonesia.</p>
                                {/* <div className="d-flex flex-column flex-md-row gap-3" data-aos="fade-up" data-aos-delay="200">
                                    <a href="https://play.google.com/store/apps/details?id=id.go.kemenag.eoffice" target="_blank" className="btn-get-started"><i className="bi bi-google-play"></i> &nbsp;&nbsp;&nbsp;Playstore</a>
                                    <a href="#about" className="btn-get-started"><i className="bi bi-apple"></i> &nbsp;&nbsp;&nbsp;App Store</a>
                                </div> */}
                            </div>
                            <div className="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-out">
                                <img src={`${baseUrl}/assets/img/hero-img.png`} className="img-fluid animated" alt="" />
                            </div>
                        </div>
                    </div>
                </section>
                <section id="about" className="about section">
                    <div className="container" data-aos="fade-up">
                        <div className="row gx-0">

                            <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
                                <div className="content">
                                    <h3>Aplikasi ini bertujuan </h3>
                                    <h2>Untuk meningkatkan efisiensi dan efektivitas dalam pengelolaan surat menyurat, pengarsipan dokumen, disposisi digital, serta komunikasi antarunit kerja, sehingga mendukung terciptanya tata kelola pemerintahan yang lebih transparan, cepat, dan akuntabel.</h2>
                                    <p>
                                        Dengan fitur-fitur modern yang sesuai dengan standar teknologi informasi, aplikasi ini juga mendukung upaya pengurangan penggunaan kertas (paperless office) dan adaptasi menuju transformasi digital.
                                    </p>
                                    {/* <div className="text-center text-lg-start">
                                        <a href="#" className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center">
                                            <span>Read More</span>
                                            <i className="bi bi-arrow-right"></i>
                                        </a>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-6 d-flex align-items-center" data-aos="zoom-out" data-aos-delay="200">
                                <img src={`${baseUrl}/assets/img/about-2.jpg`} className="img-fluid" alt="" />
                            </div>
                        </div>
                    </div>
                </section>
                <section id="values" className="values section">
                    <div className="container section-title" data-aos="fade-up">
                        <h2>Layanan</h2>
                        <p>Layanan Terbaik Kami<br /></p>
                    </div>
                    <div className="container">

                        <div className="row gy-4">

                            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                                <div className="card">
                                    <img src={`${baseUrl}/assets/img/values-1.png`} className="img-fluid" alt="" />
                                    <h3>Aksesibilitas</h3>
                                    <p>Dengan desain <i>UI/UX</i> dan dukungan teknologi berbasis web dan mobile, aplikasi ini sangat <i>user friendly</i> dan dapat diakses dari mana saja </p>
                                </div>
                            </div>

                            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                                <div className="card">
                                    <img src={`${baseUrl}/assets/img/values-2.png`} className="img-fluid" alt="" />
                                    <h3>Efisiensi</h3>
                                    <p>Aplikasi ini meminimalisir waktu yang diperlukan dalam pengelolaan administrasi perkantoran.</p>
                                </div>
                            </div>

                            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="300">
                                <div className="card">
                                    <img src={`${baseUrl}/assets/img/values-3.png`} className="img-fluid" alt="" />
                                    <h3>Efektivitas</h3>
                                    <p>Menyederhanakan proses administrasi perkantoran, mempercepat alur surat-menyurat dan akurasi pengelolaan dokumen secara digital tanpa penggunaan kertas.</p>
                                </div>
                            </div>

                        </div>

                    </div>

                </section>
                <section id="services" className="services section">


                    <div className="container section-title" data-aos="fade-up">
                        <h2>Menu</h2>
                        <p>Menu Aplikasi Kami<br /></p>
                    </div>

                    <div className="container">

                        <div className="row gy-4">

                            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                                <div className="service-item item-cyan position-relative">
                                    <i className="bi bi-envelope icon"></i>
                                    <h3>Surat</h3>
                                    <p>Membuat dan mengelola surat yang nantinya akan didistribusikan ke pihak-pihak terkait.</p>
                                    {/* <a href="#" className="read-more stretched-link"><span>Read More</span> <i className="bi bi-arrow-right"></i></a> */}
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                                <div className="service-item item-orange position-relative">
                                    <i className="bi bi-inbox icon"></i>
                                    <h3>Kotak Masuk</h3>
                                    <p>Menampilkan daftar surat atau dokumen yang diterima pengguna, lengkap dengan informasi pengirim, tanggal, dan status disposisi, sehingga memudahkan pengelolaan dan tindak lanjut secara cepat dan terorganisir.</p>
                                    {/* <a href="#" className="read-more stretched-link"><span>Read More</span> <i className="bi bi-arrow-right"></i></a> */}
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                                <div className="service-item item-teal position-relative">
                                    <i className="bi bi-archive icon"></i>
                                    <h3>Arsip</h3>
                                    <p>Menyimpan, mengelola, dan mencari dokumen secara digital, memastikan semua arsip tersimpan rapi, mudah diakses, dan aman dari risiko kehilangan.</p>
                                    {/* <a href="#" className="read-more stretched-link"><span>Read More</span> <i className="bi bi-arrow-right"></i></a> */}
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
                                <div className="service-item item-red position-relative">
                                    <i className="bi bi-calendar4-week icon"></i>
                                    <h3>Agenda</h3>
                                    <p>Mengelola jadwal kegiatan, pertemuan, atau acara penting secara terorganisir, memungkinkan pengguna untuk mencatat, memantau, dan mengingatkan agenda secara digital untuk meningkatkan produktivitas dan koordinasi.</p>
                                    {/* <a href="#" className="read-more stretched-link"><span>Read More</span> <i className="bi bi-arrow-right"></i></a> */}
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
                                <div className="service-item item-indigo position-relative">
                                    <i className="bi bi-people icon"></i>
                                    <h3>Manajemen User</h3>
                                    <p>Memungkinkan pengelolaan akun pengguna, pengaturan hak akses, serta pengawasan aktivitas untuk memastikan keamanan dan efisiensi dalam penggunaan sistem.</p>
                                    {/* <a href="#" className="read-more stretched-link"><span>Read More</span> <i className="bi bi-arrow-right"></i></a> */}
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="600">
                                <div className="service-item item-pink position-relative">
                                    <i className="bi bi-person icon"></i>
                                    <h3>Profil User</h3>
                                    <p>Menampilkan informasi pribadi pengguna, termasuk data identitas, jabatan, dan unit kerja, serta memungkinkan pengguna untuk memperbarui data sesuai kebutuhan.</p>
                                    {/* <a href="#" className="read-more stretched-link"><span>Read More</span> <i className="bi bi-arrow-right"></i></a> */}
                                </div>
                            </div>

                        </div>

                    </div>

                </section>
                <section id="portfolio" className="portfolio section">


                    <div className="container section-title" data-aos="fade-up">
                        <h2>Portfolio</h2>
                        <p>Tangkapan Layar Aplikasi</p>
                    </div>

                    <div className="container">

                        <div className="isotope-layout" data-default-filter="*" data-layout="masonry" data-sort="original-order">

                            <ul className="portfolio-filters isotope-filters" data-aos="fade-up" data-aos-delay="100">
                                <li data-filter="*" className="filter-active">All</li>
                                <li data-filter=".filter-website">Website</li>
                                <li data-filter=".filter-mobile">Mobile</li>
                            </ul>

                            <div className="row gy-4 isotope-container" data-aos="fade-up" data-aos-delay="200">
                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-mobile">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/mockup-mobile-1.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>App 1</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href={`${baseUrl}/assets/img/portfolio/mockup-mobile-1.jpg`} title="App 1" data-gallery="portfolio-gallery-app" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-website">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/mockup-web-1.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>Website 1</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href={`${baseUrl}/assets/img/portfolio/mockup-web-1.jpg`} title="Product 1" data-gallery="portfolio-gallery-product" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-mobile">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/mockup-mobile-2.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>App 2</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href={`${baseUrl}/assets/img/portfolio/mockup-mobile-2.jpg`} title="App 2" data-gallery="portfolio-gallery-branding" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-books">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/books-1.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>Books 1</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href="assets/img/portfolio/books-1.jpg" title="Branding 1" data-gallery="portfolio-gallery-book" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/app-2.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>App 2</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href="assets/img/portfolio/app-2.jpg" title="App 2" data-gallery="portfolio-gallery-app" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-website">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/mockup-web-2.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>Product 2</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href="assets/img/portfolio/product-2.jpg" title="Product 2" data-gallery="portfolio-gallery-product" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/branding-2.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>Branding 2</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href="assets/img/portfolio/branding-2.jpg" title="Branding 2" data-gallery="portfolio-gallery-branding" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-books">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/books-2.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>Books 2</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href="assets/img/portfolio/books-2.jpg" title="Branding 2" data-gallery="portfolio-gallery-book" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/app-3.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>App 3</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href="assets/img/portfolio/app-3.jpg" title="App 3" data-gallery="portfolio-gallery-app" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-website">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/product-3.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>Product 3</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href="assets/img/portfolio/product-3.jpg" title="Product 3" data-gallery="portfolio-gallery-product" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/branding-3.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>Branding 3</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href="assets/img/portfolio/branding-3.jpg" title="Branding 2" data-gallery="portfolio-gallery-branding" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-books">
                                    <div className="portfolio-content h-100">
                                        <img src={`${baseUrl}/assets/img/portfolio/books-3.jpg`} className="img-fluid" alt="" />
                                        <div className="portfolio-info">
                                            <h4>Books 3</h4>
                                            <p>Lorem ipsum, dolor sit amet consectetur</p>
                                            <a href="assets/img/portfolio/books-3.jpg" title="Branding 3" data-gallery="portfolio-gallery-book" className="glightbox preview-link"><i className="bi bi-zoom-in"></i></a>
                                            <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg"></i></a>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </section>
            </main>
            <footer id="footer" className="footer">
                {/* <div className="footer-newsletter">
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-6">
                                <h4>Join Our Newsletter</h4>
                                <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
                                <form action="forms/newsletter.php" method="post" className="php-email-form">
                                    <div className="newsletter-form"><input type="email" name="email" /><input type="submit" value="Subscribe" /></div>
                                    <div className="loading">Loading</div>
                                    <div className="error-message"></div>
                                    <div className="sent-message">Your subscription request has been sent. Thank you!</div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="footer-newsletter">
                    <div className="container footer-top">
                        <div className="row gy-4">
                            <div className="col-lg-4 col-md-6 footer-about">
                                <a href={`${baseUrl}`} className="d-flex align-items-center">
                                    <span className="sitename">E-Office Web App</span>
                                </a>
                                <div className="footer-contact pt-3">
                                    <p>Jl. Lap. Banteng Barat No.3, Ps. Baru,</p>
                                    <p>Kecamatan Sawah Besar, Kota Jakarta Pusat,</p>
                                    <p>Daerah Khusus Ibukota Jakarta,</p>
                                    <p>Kode Pos 10710</p>
                                    <p className="mt-3"><strong>Telepon:</strong> <span>(021) 3812344</span></p>
                                    <p><strong>Website:</strong> <span>www.kemenag.go.id<a href="https://kemenag.go.id" target="_blank"> <i className="bi bi-box-arrow-up-right p-2" style={{ fontSize: 14 }}></i> </a></span></p>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-6 footer-about">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.692221347008!2d106.83085747563247!3d-6.171947993815398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f6338b8ae61f%3A0xeedad0e9ebd6e11c!2sKementerian%20Agama%20Republik%20Indonesia!5e0!3m2!1sid!2sid!4v1733282693640!5m2!1sid!2sid"
                                    width="100%"
                                    height="250"
                                    style={{ border: "0" }}
                                    allowFullScreen={true}
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container copyright text-center">
                    <p>© <span>Copyright</span> <strong className="px-1 sitename">E-Office Web App</strong>- <span>All Rights Reserved</span></p>
                    <div className="credits">
                        Designed by <a href="https://kemenag.go.id/">Biro PUSDATIN</a>
                    </div>
                </div>


            </footer>
            <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
        </div>
    )
}
export default LandingPage